
import {map} from 'rxjs/operators';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Rx';

import * as selectors from '../store/reducers/index';

/**
 * This class represents the lazy loaded HomeComponent.
 */
@Component({
  selector: 'sd-home',
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent {
  name$: Observable<string>;
  constructor(public store: Store<any>) {
    this.name$ = store.select(selectors.getAuthenticationState).pipe(map(state => {
      try {
        return state.user.firstName || 'friend';
      } catch (ex) {
        return 'friend';
      }
    }));
  }
}
